import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DocumentUploadFormComponent } from '@app/components/registration/document-upload-form/document-upload-form.component';
import {
  DocumentUploadFormGroup,
  getDocumentUploadFormGroup,
} from '@app/components/registration/document-upload-form/document-upload-form.helper';
import { LegalEntityService } from '@app/services/admin/legal-entity.service';
import { AuthStore } from '@app/stores/auth.store';
import { GenericStore } from '@app/stores/generic.store';
import { ButtonComponent } from '@app/ui-components/button/button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-representative',
  templateUrl: './representative.component.html',
  styleUrl: './representative.component.scss',
  imports: [TranslatePipe, DocumentUploadFormComponent, ButtonComponent],
})
export class RepresentativeDocumentsComponent implements OnInit {
  save() {
    throw new Error('Method not implemented.');
  }
  cancelEdit() {
    throw new Error('Method not implemented.');
  }
  protected store = inject(AuthStore);
  protected genericStore = inject(GenericStore);
  documentUpload: FormGroup<DocumentUploadFormGroup>;

  constructor(
    fb: FormBuilder,
    private legalEntityService: LegalEntityService,
  ) {
    this.documentUpload = getDocumentUploadFormGroup(fb);
  }

  ngOnInit(): void {
    const legalEntity = this.store.loggedInCompanyId();
    const user = this.store.user();
    if (!legalEntity || !user) return;

    this.legalEntityService
      .getApprovalRequestFiles(legalEntity, user.id)
      .subscribe((response) => {
        const entity = response;
        console.log(entity);

        this.documentUpload.patchValue({});
      });
  }
}
